import Navbar from "./Navbar";
import Footer from "./Footer";

export default function AuthShell({ overline, title, children, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen">
      <Navbar />
      <section className="pt-36 pb-28 max-w-md mx-auto px-6">
        <p className="overline mb-3">{overline}</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white font-light tracking-tight mb-8">{title}</h1>
        {children}
      </section>
      <Footer />
    </div>
  );
}
